import type { MouseEvent } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useQuery } from '@tanstack/react-query'

import { ArticleList } from '#/local/component/ArticleList'

import { fetchArticleListByQuery } from '#/local/repository/Article'
import { sendReport } from '#/local/repository/Report'

import { Config } from '#/global/helper/Config'
import { MessageFlash } from '#/global/helper/MessageFlash'

export const Article = () => {
    const lang = Config.getLang()
    const [searchParameters, setSearchParameters] = useSearchParams()
    const query = searchParameters.get('query')

    const page = searchParameters.get('page') ? Number(searchParameters.get('page')) : 1

    const articleList = useQuery({
        queryKey: ['article', { page, query }],
        queryFn: async () => fetchArticleListByQuery({ query: query!, page }),
        enabled: !!query,
    })

    const handleSetPage = (page: number) => {
        const urlParameters = new URLSearchParams(window.location.search)
        urlParameters.set(`page`, page.toString())
        setSearchParameters(urlParameters)
    }

    if (articleList.isError) {
        MessageFlash.add({
            message: 'Nastala chyba při načítání článků.',
            type: 'error',
        })
    }

    const handleSendReport = (event: MouseEvent<HTMLAnchorElement>, { code, link }: { code: string, link: string }) => {
        event.preventDefault()
        query && void sendReport(query, 'articles', code, link)
    }

    return (
        <>
            {articleList.isPending && <ArticleList loadingState />}
            {articleList.isSuccess && (
                <ArticleList
                    itemsCount={articleList.data.itemsCount}
                    lang={lang}
                    list={articleList.data.list}
                    onItemClick={handleSendReport}
                    page={page}
                    setPage={handleSetPage}
                />
            )}
        </>
    )
}
